export function replaceOrUpdateQueryParam(param: string, newval: string, search: string) {
  const regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?');
  // Query param not available. Only extend the param.
  if (!regex.test(search)) {
    return `${search}?${param}=${newval}`;
  }
  // Replace if exists
  const query = search.replace(regex, '$1').replace(/&$/, '');
  return query + (newval ? param + '=' + newval : '');
}
